import client from "../utils/client";

// ***Spotlight World Cup API Endpoints***
const fetchUserStatus = async (props) => {
  const { user_id, contest_id, spotlight_uuid } = props;

  const url = `/api/status`;
  const response = await client({ returnStatus: true }).get(url, {
    params: {
      contest_id,
      user_id,
      spotlight_uuid,
    },
  });

  return {
    ...response.data,
    __httpStatus: response.status,
  };
};

// Marks the user as having entered the contest (sets `started` server-side).
// Fired once from Overview's "Start Making Picks" button; the caller
// re-dispatches getStatusAction afterward to pick up the refreshed entry_page
// rather than relying on this response's shape.
const enterContest = async (props) => {
  const { user_id, contest_id } = props;

  const url = `/api/enter_contest`;
  const response = await client({ returnStatus: true }).post(url, {
    contest_id,
    user_id,
  });

  return {
    ...response.data,
    __httpStatus: response.status,
  };
};

// ***Spotlight API Endpoints***
const fetchUser = () => {
  const url = "/users/me";

  //automatically consumes token from storage
  return new Promise((resolve, reject) => {
    client({
      isSpotlightRoute: true,
    })
      .get(url)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};

const getSettings = async (userId) => {
  const url = `/users/${userId}/settings/`;
  try {
    const data = await client({
      isSpotlightRoute: true,
    }).get(url);
    return data;
  } catch (err) {
    console.log(err.message);
  }
  return null;
};

export { fetchUser, fetchUserStatus, enterContest, getSettings };
